import React from 'react';

import './styles.css';

import { deleteStudentNotification, assignReadStudentNotification } from '../../../../../services/academy/studentsServices';

import { FaCheck, FaTrash } from 'react-icons/fa';

export default function NotificationCard(props) {

    const deleteNotification = async () => {
        // eslint-disable-next-line no-restricted-globals
        if (confirm("Deseja apagar essa notificação?")) {
            try {
                const id = localStorage.getItem('_id');
                await deleteStudentNotification(id, props.id);
                props.setNotifications((prevState) => {
                    return prevState.filter(obj => obj.id !== props.id);
                });
            } catch (err) {
                console.log(err.message);
                alert("Erro ao deletar notificação, tente novamente!.");
            }
        }
    }

    const readNotification = async () => {
        try {
            const id = localStorage.getItem('_id');
            await assignReadStudentNotification(id, props.id);
            props.setNotifications((prevState) => {
                return prevState.map(obj => {
                    if (obj.id === props.id)
                        obj.lido = true;
                    return obj;
                });
            });
        } catch (err) {
            console.log(err.message);
            alert("Erro ao marcar notificação como lida, tente novamente!.");
        }
    }
    
    return (
        <li className='notifications-group-card'>
            <h4>{props.tittle}</h4>
            <p>{props.text}</p>
            <p className='date-info'>{props.date}</p>

            <div className='notifications-group-card-buttons'>
                {
                    !props.lido ?
                        <button className='notifications-group-card-button green' onClick={readNotification}><FaCheck /></button>
                        :
                        null
                }
                <button className='notifications-group-card-button red' onClick={deleteNotification}><FaTrash /></button>
            </div>
        </li>
    )
}